const IMG_CLOUD_BASE_PATH = '/img-cloud';

export const getImgCloudBasename = (pathname: string = window.location.pathname): string => {
  return pathname === IMG_CLOUD_BASE_PATH || pathname.startsWith(`${IMG_CLOUD_BASE_PATH}/`)
    ? IMG_CLOUD_BASE_PATH
    : '';
};

export const buildImgCloudRoutePath = (routePath: string): string => {
  const normalizedRoute = routePath.startsWith('/') ? routePath : `/${routePath}`;
  return `${getImgCloudBasename()}${normalizedRoute}`;
};

export const buildImgCloudRouteUrl = (routePath: string): string => {
  return `${window.location.origin}${buildImgCloudRoutePath(routePath)}`;
};

export const normalizeLegacyHashRoute = (): void => {
  const { hash, pathname, search } = window.location;
  if (!hash.startsWith('#/')) {
    return;
  }

  const basename = getImgCloudBasename(pathname);
  const hashRoute = hash.slice(1);
  const targetPath =
    basename && (hashRoute === basename || hashRoute.startsWith(`${basename}/`))
      ? hashRoute
      : `${basename}${hashRoute}`;
  const targetUrl = new URL(targetPath, window.location.origin);
  if (!targetUrl.search && search) {
    targetUrl.search = search;
  }

  window.history.replaceState(null, '', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
};
